<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="btn-group-justify-end">
          <button class="button" @click="deleteForm">폼 삭제하기</button>
          <button class="button is-primary" @click="selectForm" v-if="page==='grade'">파트너 폼 선택하기</button>
          <button class="button is-primary" @click="saveData" v-else>저장하기</button>
        </div>
      </div>

      <!-- 파트너 기본 정보 -->
      <div class="column is-full">
        <!-- 탭 -->
        <div class="flex flex-center" style="font-size: .9rem;">
          <div class="lp-tab flex-center"
               :class="{'lp-tab-selected': selectedItem.form_id===type.value}"
               v-for="(type, idx) in value.types"
               :key="idx">
            <div class="flex"
                 style="padding: 10px 24px"
                 @click="changeTab(type,idx)">
              <input class="input lp-form-type-input"
                     :class="{'lp-tab-input-selected': selectedItem.form_id===type.value}"
                     :value="type.label"
                     @input="e => inputLabel(e, type)"
                     type="text"
                     maxlength="15">
            </div>
            <div class="tab-divider" :class="{'divider-none': idx === selectedIndex-1 || idx=== selectedIndex}"></div>
          </div>
          <div class="lp-form-add" @click="addForm">+</div>
        </div>
        <div class="box" style="border-top-left-radius: unset">
          <admin-box-item title="파트너 기본 정보: ">
            <div slot="header-right-spot">
              <div class="lp-group-justfy-end"
                   style="margin:0;position:absolute;top:-4px;left:156px;font-size:21px;font-weight:300;">
                <span v-text="selectedItem.name"></span>
              </div>
            </div>
            <div style="overflow-x: auto">
              <div style="width: 100%">
                <div class="flex" style="border-bottom: 2px solid #dbdbdb; text-align: center">
                  <div style="width:24px"></div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">필드명 및 포맷 비주얼</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">타입</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">활성화 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">필수입력 여부</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">label</div>
                  <div class="lp-param-td lp-param-head" style="width: 10%">description</div>
                  <div class="lp-param-td lp-param-head" style="width: 15%">placeholder</div>
                  <div class="lp-param-td lp-param-head" style="width: 20%">Validation</div>
                </div>

                <draggable v-model="value.data">
                  <div v-for="(info, idx) in value.data" :key="idx" class="flex">
                    <!--<div v-for="(info, idx) in value.data" :key="idx" v-if="!info.is_param" class="flex">-->
                    <div style="color: #bababa">
                      <i class="material-icons lp-drag-indicator"
                         style="line-height:2.5rem;padding:0">drag_indicator</i>
                    </div>
                    <div class="lp-param-td" style="width: 15%">
                      <div class="package-name" v-if="info.package">({{ packageName(info.package) }})</div>
                      <div>{{ info.name }}</div>
                    </div>
                    <div class="lp-param-td" style="width: 10%"><span v-if="info.format">{{ convertFormat(info.format) }}</span></div>
                    <div class="lp-param-td" style="width: 10%">
                      <toggle-button @change="e=>changeEnable(e, idx)"
                                     :value="info.enable"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'활성화', 'unchecked':'비활성화'}"></toggle-button>
                    </div>
                    <div class="lp-param-td" style="width: 10%">
                      <toggle-button @change="e => selectValidate(e, idx)"
                                     :value="info.validate.valid_required"
                                     :sync="true"
                                     class="changed-font"
                                     :width="70"
                                     :height="24"
                                     :labels="{'checked':'사용', 'unchecked':'미사용'}"></toggle-button>
                    </div>
                    <div class="lp-param-td" style="width: 10%"><input class="input"
                                                                       :value="info.label"
                                                                       @input="e=>inputValue(e.target.value, 'label', idx)"
                                                                       type="text" maxlength="50"></div>
                    <div class="lp-param-td" style="width: 10%"><input class="input"
                                                                       :value="info.description"
                                                                       @input="e=>inputValue(e.target.value, 'description', idx)"
                                                                       type="text" maxlength="70"></div>
                    <div class="lp-param-td" style="width: 15%"><input class="input"
                                                                       :value="info.placeholder"
                                                                       @input="e=>inputValue(e.target.value, 'placeholder', idx)"
                                                                       type="text" maxlength="50"></div>

                    <div class="lp-param-td" style="width: 20%">
                      <div  v-if="info.format === 'CInput_text'"
                            style="font-size:12px;white-space: pre-wrap">
                        <i class="material-icons unselect btn-setting"
                           style="font-size:22px" @click="clickSetting(info)">settings</i><br>{{ validateText(info.validate) }}
                      </div>
                    </div>
                  </div>
                </draggable>
              </div>
            </div>
          </admin-box-item>
        </div>
      </div>

      <sweet-modal ref="validModal" overlay-theme="dark">
        <div v-if="modalInfo">
          <div class="modal-title">'{{ modalInfo.name }}' 필드 Validation 설정</div>
          <div class="columns is-multiline">
            <div class="column is-2">
              <div class="modal-sub-title">숫자 허용 여부</div>
              <toggle-button @change="e => modalInfo.validate.num = e.value"
                             :value="modalInfo.validate.num"
                             :sync="true"
                             class="changed-font"
                             :width="100"
                             :height="24"
                             :labels="{'checked':'숫자 허용', 'unchecked':'숫자 불가'}"></toggle-button>
            </div>
            <div class="column is-2">
              <div class="modal-sub-title">알파벳 대문자 허용 여부</div>
              <toggle-button @change="e => modalInfo.validate.alpha_g = e.value"
                             :value="modalInfo.validate.alpha_g"
                             :sync="true"
                             class="changed-font"
                             :width="100"
                             :height="24"
                             :labels="{'checked':'알파벳 대문자 허용', 'unchecked':'알파벳 대문자 불가'}"></toggle-button>
            </div>
            <div class="column is-2">
              <div class="modal-sub-title">알파벳 소문자 허용 여부</div>
              <toggle-button @change="e => modalInfo.validate.alpha_s = e.value"
                             :value="modalInfo.validate.alpha_s"
                             :sync="true"
                             class="changed-font"
                             :width="100"
                             :height="24"
                             :labels="{'checked':'알파벳 소문자 허용', 'unchecked':'알파벳 소문자 불가'}"></toggle-button>
            </div>
            <div class="column is-2">
              <div class="modal-sub-title">특수문자 허용 여부</div>
              <toggle-button @change="e => modalInfo.validate.special = e.value"
                             :value="modalInfo.validate.special"
                             :sync="true"
                             class="changed-font"
                             :width="100"
                             :height="24"
                             :labels="{'checked':'특수문자 허용', 'unchecked':'특수문자 불가'}"></toggle-button>
            </div>
            <div class="column is-2">
              <div class="modal-sub-title">최소 글자수</div>
              <input class="input" type="number" v-model="modalInfo.validate.min_length">
            </div>
            <div class="column is-2">
              <div class="modal-sub-title">최대 글자수</div>
              <input class="input" type="number" v-model="modalInfo.validate.max_length">
            </div>
          </div>
        </div>
        <div class="modal-btn" style="padding-top:8px;">
          <button class="modal-upload" @click.stop.prevent="$refs.validModal.close()">확인</button>
        </div>
      </sweet-modal>


      <div class="column is-full">
        <div class="btn-group-justify-end">
          <button class="button is-primary" @click="selectForm" v-if="page==='grade'">파트너 폼 선택하기</button>
          <button class="button is-primary" @click="saveData" v-else>저장하기</button>
        </div>
      </div>
    </div>

    <modal name="changeTabModal" :adaptive="true" :width="600" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <div>탭을 변경하기 전 저장하시겠습니까?</div>
        <div class="btn-group-justify-end">
          <button class="button is-primary" style="margin-left: 0;" @click="confirmChangeTab">예</button>
          <button class="button is-light" style="margin-left:6px" @click="exitChangeTab">아니오</button>
          <button class="button is-light" style="margin-left:6px" @click="cancelChangeTab">취소</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import {SweetModal} from 'sweet-modal-vue'
  import LpSortDropDown from '../../module/common/LpSortDropDown'
  import LpInputText from '../../module/common/LpInputText'
  import LpRadio from '../../module/common/LpRadio'
  import LpCheckBool from '../../module/common/LpCheckBool'
  import LpModal from '../../module/common/LpModal.vue'
  import AdminBoxItem from "../../module/admin/AdminBoxItem";
  import draggable from 'vuedraggable'
  import ParamMixin from "@/mixins/ParamMixin";

  export default {
    name: 'PartnerParamForm',
    layout: 'Main',
    props: ['grade_id', 'page'],
    mixins: [
      ParamMixin
    ],
    components: {
      AdminBoxItem,
      LpSortDropDown,
      LpInputText, LpRadio, LpModal,
      LpCheckBool, draggable,
      SweetModal
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          if(this.value.types.length>0) {
            this.selectedItem.form_id = this.value.types[0].value;
            this.getData();
          }
        }
      }
    },
    computed: {
      selectedIndex() {
        if(this.value && this.value.types.length>0) {
          for(let i=0; i<this.value.types.length; i++) {
            if(this.value.types[i].value===this.selectedItem.form_id) {
              return i;
            }
          }
        }
      }
    },
    data() {
      return {
        modify: false,
        mode: '',
        value: {
          data: [],
          types: [],
        },
        selectedItem: {
          form_id: 0,
          name: ''
        },
        beforeItem: {
          form_id: 0,
          name: ''
        },
        afterItem: {
          form_id: 0,
          name: ''
        },
        // 맞춤 db list
        param_list: [],
        modalInfo: undefined
      }
    },
    created() {
      this.getData();
    },
    methods: {
      packageName (pack) {
        let name = '';
        switch(pack) {
          case 'call':
            name = '전화연결';
            break;
          case 'estimate':
            name = '견적';
            break;
          case 'delivery':
            name = '파트너배송';
            break;
          case 'counsel':
            name = '상담신청';
            break;
          case 'meet':
            name = '모임신청';
            break;
          case 'outlink':
            name = '아웃링크';
            break;
        }
        return name;
      },
      inputValue(value, type, idx) {
        this.modify = true;
        this.value.data[idx][type] = value;
      },
      clickSetting(info) {
        this.modify = true;
        this.modalInfo = info;
        this.$refs.validModal.open();
      },
      validateText(valid) {
        let result = '숫자 ' + this.validTypeText(valid.num);
        result += ', 알파벳 소' + this.validTypeText(valid.alpha_s);
        result += ', 대 ' + this.validTypeText(valid.alpha_g);
        result += ', 특수문자 ' + this.validTypeText(valid.special);
        result += '\n 최소글자수 ' + valid.min_length;
        result += ', 최대글자수 ' + valid.max_length;

        return result;
      },
      validTypeText(v) {
        return v ? 'O' : 'X';
      },
      changeEnable(e, idx) {
        this.modify = true;
        this.value.data[idx].enable = e.value;
        if(this.page==='grade') {
          this.value.data[idx].validate.valid_required = e.value;
        }
      },
      deleteForm() {
        if (this.selectedItem.form_id === 0){
          for(let i=0; i<this.value.types.length; i++){
            if(this.value.types[i].value===0){
              removeIndex(this.value.types,i);
            }
          }
        }
        else {
          let value = {
            id: this.selectedItem.form_id,
            url: 'partner/formdata/',
            title: '폼을 삭제하시겠습니까?'
          }
          this.$store.commit('openModal', {type: 'modal-delete', value: value, width: 500});
        }
      },
      // 활성화 여부
      selectValidate(e, idx) {
        this.modify = true;
        this.value.data[idx].validate.valid_required = e.value;
        this.value.data[idx].validate.required = e.value;
      },
      // 파트너 폼 이름
      inputLabel(e, type){
        this.modify = true;
        type.label = e.target.value;
        this.selectedItem.name = e.target.value;
      },
      // 폼 추가하기
      addForm() {
        let type = {
          label: '사본',
          value: 0,
        }
        this.value.types.push(type);

        this.value.name = '사본';
        this.value.form_id = 0;
        this.$axios.post('admin/partner/formdata', this.value).then(res => {
          if (res.status === 200) {
            this.toast('저장되었습니다.');

            this.$axios.get('admin/partner/formdata').then(res=> {
              this.value.types = res.data;
              this.selectedItem.name = this.value.types[this.value.types.length-1].label;
              this.selectedItem.form_id = this.value.types[this.value.types.length-1].value;
            })
          }
        })
      },
      // 탭 변경 취소
      cancelChangeTab() {
        this.selectedItem = this.beforeItem;
        this.$modal.hide('changeTabModal');
      },
      exitChangeTab() {
        this.selectedItem = this.afterItem;
        this.getDetail();
        this.$modal.hide('changeTabModal');
        this.modify = false;
      },
      // 탭 변경
      changeTab(type, idx) {
        if(this.selectedItem.form_id === type.value) {
          return;
        }
        this.beforeItem = {
          form_id: this.selectedItem.form_id,
          name: this.selectedItem.name
        }
        this.afterItem = {
          form_id: type.value,
          name: this.value.types[idx].label
        }
        // 수정 이력이 없으면 탭 바로 변경
        if(!this.modify) {
          this.selectedItem = this.afterItem;
          this.getDetail();
        }
        else this.$modal.show('changeTabModal');
      },
      // 폼 정보 변경
      confirmChangeTab() {
        this.saveData();
        this.selectedItem = this.afterItem;
        if(this.selectedItem.form_id>0) {
          this.getDetail();
        }
        // 사본 클릭했을 경우 enable = false (비활성화)
        else {
          for(let i=0; i<this.value.data.length; i++){
            this.value.data[i].enable = false;
          }
        }
        this.$modal.hide('changeTabModal');
        this.modify = false;
      },
      // 폼 리스트 가져오기
      getData() {
        this.$axios.get('admin/partner/formdata').then(res => {
          this.value.types = res.data;
          //this.selectedItem.name = this.value.types[0].label;
          if(this.selectedItem.name==='' && this.value.types.length > 0){
            this.selectedItem.name = this.value.types[0].label;
            this.selectedItem.form_id = this.value.types[0].value;
            if(this.selectedItem.form_id > 0) this.getDetail();
            else this.paramAllList();
          }
          else this.paramAllList();
        })
      },
      // 폼 상세 가져오기
      getDetail(){
        this.$axios.get('admin/partner/formdata/' + this.selectedItem.form_id).then(res=>{
          if(res.status===200) {
            this.value.data = res.data.data;
            this.paramAllList();
          }
        })
      },
      async selectForm() {
        await this.saveData();
        this.$emit('closeModal');
        setTimeout(() => {
          this.$emit('selectForm', this.selectedItem.form_id);
        },1000)
      },
      checkPackage () {
        let boolean = true;
        let packs = this.$store.getters.getPackages;
        let pack_list = packs.map(item => {
          return item.name;
        })
        for(let i=0; i<this.value.data.length; i++) {
          let item = this.value.data[i];
          if (item.package && item.enable) {
            if (pack_list.indexOf(item.package) === -1) {
              boolean = false;
              break;
            }
          }
        }
        return boolean;
      },
      saveData() {
        if(!this.checkPackage()) {
          this.toast('서비스에 적합한 파트너 종류 필드를 활성화 하세요.');
          return;
        }
        if(this.value.types.length===0) {
          this.toast('폼을 추가해주세요');
          return;
        }
        this.value.name = this.selectedItem.name;
        this.value.form_id = this.selectedItem.form_id;
        if(this.selectedItem.form_id===0) {
          if(this.grade_id){
            this.value.grade_id = this.grade_id;
          }
          this.$axios.post('admin/partner/formdata', this.value).then(res => {
            if (res.status === 200) {
              this.toast('저장되었습니다.');
              this.modify = false;
              if(this.grade_id){
                this.$emit('closeModal');
              }

            }
          })
        }
        else {
          this.$axios.patch('admin/partner/formdata/' + this.selectedItem.form_id, this.value).then(res => {
            if (res.status === 200) {
              this.toast('저장되었습니다.');
              this.modify = false;
              if(this.grade_id){
                this.$emit('closeModal');
              }
            }
          })
        }
      },
      paramAllList() {
        // 파라미터 리스트
        this.$axios.get(this.getUrl('partner/param')).then(res => {
          this.param_list = res.data;
          this.checkParam(this.param_list);
        })
      },
      checkParam(param) {
        if ( param === undefined || param.length === 0 ) {
          return;
        }
        let id_list = this.value.data.map(item => {
          return item.id;
        })
        param.forEach(item1 => {
          /* value_
          * param_id
          * param_type
          * choice_items */
          if (!id_list.includes(item1.id)) {
            if (item1.param_type >= 0 && item1.param_type <= 8) {
              this.value.data.push(item1)
            }
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .tr-whole-borde th
    padding 12px 6px
    text-align center

  .many-field-tr td
    padding 6px

  .td-btn
    cursor pointer

  .td-btn:hover
    background-color #caf6ec
    font-weight bold
    font-size 1rem
    color $primary

  .prod-list-page-selected
    color #18a4ed

  .prod-list-page-not-selected
    color #666

  .primary
    color $primary

  .prod-tag
    background-color #ebab39
    display inline-block
    padding 4px 10px
    color #fff
    border-radius 3px
    margin 2px

  .prod-search-bgcolor
    background-color #f1f7f8

  .lp-form-type
    border 1px solid #7a7a7a
    border-radius 3px
    cursor pointer
    margin-right 8px
    margin-bottom 2px
    position relative

  .lp-form-close
    position absolute
    right 2px
    top 5px
    font-size 1.5rem

  .selected
    color $primary
    border 1px solid $primary
    background-color unset

  .lp-form-add
    padding 10px 24px
    text-align center
    cursor pointer
    font-size 20px

  .lp-form-type-input
    border 0
    box-shadow unset
    padding-right 24px
    background-color #e9e9e9

  .lp-param-td
    padding 0.5em 0.75em
    text-align center

  .lp-param-head
    color #363636
    font-weight bold

  .lp-tab
    display flex
    color #555
    margin-bottom -1px

  .lp-tab-selected
    border 1px solid #ccc
    border-bottom 0
    background-color white
    color #555
    border-top-left-radius 4px
    border-top-right-radius 4px

  .lp-tab-input-selected
    background-color white !important

  .divider-none
    display none

  .tab-divider
    height 28px
    background-color #dbdbdb
    width 1px

  .modal-btn
    display flex
    justify-content flex-end
    padding 28px 0

  .modal-cancel
  .modal-upload
    border none
    border-radius 4px
    font-size 12px
    padding 10px 12px
    color #666
    cursor pointer
    margin 0 2px

  .modal-title
    margin-bottom 20px

  .modal-sub-title
    margin 12px 8px
    font-size 13px

  .btn-setting:hover
    color #ff5722

  .package-name
    color $primary
    font-size 11px
</style>
